export default __webpack_public_path__ + "static/SRUS BC420 - Product Specifications & Technical Data-f6a1712f701f35c6fddf2f268e077a63.pdf";